module.exports = __webpack_public_path__ + "static/img/tooltip-rectangular-swath.9033080.png";